import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';

export const paymentsRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'payments' },
    loadComponent: () => import('./payments/payments.page').then((m) => m.PaymentsPage),
    path: '',
  },
  {
    canActivate: [sessionGuard],
    data: { key: 'payment-details' },
    loadComponent: () => import('./payment-details/payment-details.page').then((m) => m.PaymentDetailsPage),
    path: ':chargeIntentId',
  },
];
